import { useEffect } from 'react';
import { useMessageStore } from '../store/messageStore';
import { useAuthStore } from '../store/authStore';

const POLL_INTERVAL_MS = 30_000;

export function useUnreadCount() {
  const { isAuthenticated } = useAuthStore();
  const { unreadCount, refreshUnreadCount } = useMessageStore();

  useEffect(() => {
    if (!isAuthenticated) return;

    // Fetch immediately
    refreshUnreadCount();

    // Then poll every 30 seconds
    const interval = setInterval(refreshUnreadCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, refreshUnreadCount]);

  return unreadCount;
}
